import React, { ReactNode } from "react";
import "./secondaryButton.css";

interface SecondaryButtonProps {
  onClick?: () => void;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  icon?: ReactNode;
}

export default function SecondaryButton({
  onClick,
  children,
  className = "",
  disabled = false,
  type = "button",
  icon
}: SecondaryButtonProps) {
  return (
    <button
      className={`secondaryBtn ${className}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      <div className="btn-content">
        {icon && <span className="btn-icon">{icon}</span>}
        {children}
      </div>
    </button>
  );
} 